/**
 * Supported UI locales — single source of truth.
 *
 * The deploy entrypoint substitutes `environment.DEFAULT_LANGUAGE` at runtime; until then it
 * holds the literal build-time placeholder `'DEFAULT_LANGUAGE'`. Validating any candidate
 * language against this list rejects that placeholder — and any stale or unsupported value —
 * without needing to special-case the placeholder string.
 */
export const SUPPORTED_LOCALES = ['et', 'fr', 'en', 'es', 'ar', 'pt'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

/** Last-resort locale when neither localStorage nor the environment default is valid. */
export const DEFAULT_LOCALE: SupportedLocale = 'en';

/** Type guard: true only when `value` is one of {@link SUPPORTED_LOCALES}. */
export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return (
    typeof value === 'string' &&
    (SUPPORTED_LOCALES as readonly string[]).includes(value)
  );
}
